/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { SearchOutlined } from '@ant-design/icons'
import { Col, Row, Space, Input, Popconfirm, Image } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { selectCurrentUser } from 'Store/user/selector'
import { formatDateTime, getMenuTypeName, getRedeemStatus, numberWithComma } from 'helpers/format'
import { StatusTag } from 'Components/utilities'
import { TableListPage } from 'Components/common/Table'
import { PrimaryButton } from 'Components/button'
import { Pagination } from 'Components/Pagination'
import { menuBurnPointStatus, menuPointUserType } from 'helpers/constanst'
import { SelectItem } from 'Components/form'
import { redeemListAPI, updateRedeemStatusAPI } from 'Store/point/api'
import { PointRedeemData, PointRedeemReq, RedeemItem, UpdateRedeemStatusReq } from 'Store/point/types'
import { selectActionEvent, selectPointRedeemList } from 'Store/point/selector'
import { EventModal } from 'Components/modal'
import { clearEventAction } from 'Store/point/actions'
import theme from 'Components/common/Theme'

type Props = {} & ReduxProps

const BurnPoint: React.FunctionComponent<Props> = props => {
  const { currentUser, pointRedeem, actionEvent } = props
  const listEvent = pointRedeem.event
  const dispatch = useDispatch()
  const [visibleId, setVisibleId] = useState(0)
  const [updatingStatus, setUpdatingStatus] = useState('')

  const [filter, setFilter] = useState({
    keyword: '',
    start_date: '',
    end_date: '',
    status: '',
    type: 'buyer',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = pointRedeem.meta
  const datas = pointRedeem.data

  const onGetDataList = (): void => {
    const req: PointRedeemReq = {
      keyword: filter.keyword?.trim() || '',
      status: filter.status,
      type: filter.type,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
    }
    dispatch(redeemListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onUpdateRedeemStatus = (id: number, status: string): void => {
    const req: UpdateRedeemStatusReq = {
      id,
      status,
    }
    dispatch(updateRedeemStatusAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetDataList()
    }
  }, [pagination])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const renderStatus = (status: string, record: any) => {
    if (status === 'reserved') {
      return (
        <Popconfirm
          title={`ยืนยันการเปลี่ยนสถานะเป็น "${getRedeemStatus(updatingStatus).text}" หรือไม่?`}
          visible={visibleId === record?.id}
          onConfirm={() => {
            setVisibleId(0)
            onUpdateRedeemStatus(record?.id || 0, updatingStatus)
          }}
          okButtonProps={{ loading: false }}
          onCancel={() => {
            setVisibleId(0)
            setUpdatingStatus('')
          }}
          okText="ยืนยัน"
          cancelText="ยกเลิก"
          placement="topLeft"
        >
          <SelectItem
            name={'type'}
            label={''}
            isRequired={true}
            value={status}
            menu={menuBurnPointStatus}
            placeHolder={''}
            onChange={(val: any): void => {
              setVisibleId(record?.id || 0)
              setUpdatingStatus(val)
            }}
            allowClear={false}
            disabled={visibleId !== record?.id && visibleId !== 0}
          />
        </Popconfirm>
      )
    }

    return <StatusTag isPass={status === 'success'} text={getMenuTypeName(menuBurnPointStatus, status)} />
  }

  const columns = [
    {
      title: '',
      dataIndex: 'redeem_item',
      key: 'redeem_item_title',
      width: '80px',
      render: (redeem_item: RedeemItem) => (
        <Space>
          <Image width={50} src={redeem_item.image_url} />
        </Space>
      ),
    },
    {
      title: 'รายการของรางวัล',
      dataIndex: 'redeem_item',
      key: 'redeem_item_title',
      width: '250px',
      render: (redeem_item: RedeemItem) => redeem_item.title,
    },
    {
      title: 'วันที่ทำรายการ',
      key: 'redeem_date',
      dataIndex: 'redeem_date',
      render: (date: string) => formatDateTime(date),
    },
    {
      title: 'Email/เบอร์โทรศัพท์',
      dataIndex: 'name',
      key: 'name',
      render: (name: string, record: PointRedeemData) => `${name} - ${record.phone_no}`,
    },
    // {
    //   title: 'จำนวนคะแนนที่ใช้แลก',
    //   dataIndex: 'point_spent',
    //   key: 'point_spent',
    //   render: (val: number) => ` ${numberWithComma(val)} คะแนน`,
    // },
    {
      title: <Center>จำนวนคะแนนที่ใช้แลก</Center>,
      dataIndex: 'point_spent',
      key: 'point_spent',
      render: (val: number) => (
        <Center>
          <PointBurn>-{numberWithComma(val)}</PointBurn> คะแนน
        </Center>
      ),
    },
    {
      title: 'ที่อยู่ในการจัดส่งของรางวัล',
      key: 'address',
      dataIndex: 'address',
    },
    {
      title: 'สถานะการแลกของรางวัล',
      key: 'redeem_status',
      dataIndex: 'redeem_status',
      width: '150px',
      render: renderStatus,
    },
  ]

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="bottom">
        <MyCol xs={24} md={20}>
          <Row gutter={[16, 16]} align="bottom">
            <Col>
              <Space direction="horizontal">
                <span>ค้นหาจาก</span>
                <SelectItem
                  name={'type'}
                  label={''}
                  isRequired={true}
                  value={filter.type}
                  menu={menuPointUserType}
                  placeHolder={'ประเภทลูกค้า'}
                  onChange={(val: any): void => onFilter('type', val)}
                  allowClear={false}
                />
              </Space>
            </Col>
            <Col md={8} xs={24}>
              <SearchInput
                placeholder={filter.type === 'buyer' ? 'ค้นหาเบอร์โทรศัพท์' : 'ค้นหาด้วย Email ร้านค้า'}
                prefix={<SearchOutlined />}
                allowClear
                value={filter.keyword}
                onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
              />
            </Col>
            <Col md={8} xs={24}>
              <SelectItem
                name={'status'}
                label={''}
                isRequired={true}
                value={filter.status}
                menu={menuBurnPointStatus}
                placeHolder={'สถานะการแลกของรางวัล'}
                onChange={(val: any): void => onFilter('status', val)}
                allowClear={true}
              />
            </Col>
            <Col>
              <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
            </Col>
          </Row>
        </MyCol>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    setUpdatingStatus('')
    onGetDataList()
  }

  return (
    <>
      {FilterContent}
      <EventModal
        event={[actionEvent]}
        enable={true}
        successCalback={onEventSuccess}
        errorCalback={clearEvent}
      />
      <TableListPage
        columns={columns}
        datas={datas}
        isLoading={listEvent.IsLoading}
        paginationContent={PaginationContent}
        size="small"
      />
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    pointRedeem: selectPointRedeemList(state),
    actionEvent: selectActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const MyCol = styled(Col)`
  margin-top: 10px;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

const Center = styled.div`
  text-align: center;
`

const PointBurn = styled.span`
  color: ${theme.colors.error};
  font-size: ${theme.typography.body3};
`

export default connect(mapStateToProps)(BurnPoint)
